import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { RemoveIcon, MicrophoneIcon } from '@estee/elc-icons';
import { backgroundWhiteTheme, transparentButton } from '../../../theme/default-theme';
import { ContentSpacing } from '@estee/elc-base-theme';
import { translate, ITranslationsCollection } from '@estee/elc-service';
import { VoiceSearchMessage } from './VoiceSearchMessage';
import { classes } from '../../utils/Classes';

const CloseIconWrapper = styled.button`
    position: absolute;
    top: ${ContentSpacing.space16};
    right: ${ContentSpacing.space16};
    ${transparentButton};
`;

const SpeakScreenWrapper = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    overflow: auto;
    ${backgroundWhiteTheme};
`;

const SpeakMicrophoneWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
`;

const iconSpeakWrapperClassnames = classes('search-speak-icon-wrapper');
const searchMicrophoneIconClassnames = classes('search-speak-microphone-icon');
const searchMicErrorWrapperClassnames = classes('search-microphone-wrapper');
const speakWrapperClassnames = classes('search-speak-wrapper');
const searchIconCloseWrapperClassnames = classes('search-close-icon-wrapper');
const searchIconCloseClassnames = classes('search-close-icon');

export interface ISpeakScreenProps {
    closeSpeakScreen(): void;
    isSpeakScreenOpen: boolean;
    translations?: ITranslationsCollection;
    allowPermission: boolean;
    voiceSearchFailure: boolean;
    voiceSearchTerm: string;
    searching: boolean;
}

@translate(['closeLabel', 'searchButtonLabel', 'voiceSearchIconLabel'])
@observer
export class SpeakScreen extends React.Component<ISpeakScreenProps> {
    public render() {
        const {
            closeSpeakScreen,
            isSpeakScreenOpen,
            allowPermission,
            voiceSearchFailure,
            voiceSearchTerm,
            searching
        } = this.props;
        const { closeLabel, searchButtonLabel, voiceSearchIconLabel } = this.props
            .translations as ITranslationsCollection;

        return (
            isSpeakScreenOpen && (
                <SpeakScreenWrapper className={speakWrapperClassnames}>
                    <CloseIconWrapper
                        className={searchIconCloseWrapperClassnames}
                        onClick={closeSpeakScreen}
                        data-test-id="SEA-Close-Speak-Now"
                        aria-label={`${closeLabel} ${searchButtonLabel}`}
                        title={`${closeLabel} ${searchButtonLabel}`}
                    >
                        <RemoveIcon className={searchIconCloseClassnames} />
                    </CloseIconWrapper>
                    <VoiceSearchMessage
                        allowPermission={allowPermission}
                        voiceSearchFailure={voiceSearchFailure}
                        voiceSearchTerm={voiceSearchTerm}
                        searching={searching}
                    />
                    {!voiceSearchFailure && !allowPermission && (
                        <SpeakMicrophoneWrapper className={searchMicErrorWrapperClassnames}>
                            <div
                                className={iconSpeakWrapperClassnames}
                                data-test-id="SEA-Speak-Now-Icon"
                                aria-label={voiceSearchIconLabel}
                                title={voiceSearchIconLabel}
                            >
                                <MicrophoneIcon className={searchMicrophoneIconClassnames} />
                            </div>
                        </SpeakMicrophoneWrapper>
                    )}
                </SpeakScreenWrapper>
            )
        );
    }
}
